<template>
    <div>
        <div class="flex mb-4">
            <a href="#"
                class="w-full py-2 px-2 border  focus:outline-none"
                :class="[active ? 'bg-green-100 text-gray-900 border-green-200 hover:text-green-800' : 'bg-gray-100 text-gray-600 border-gray-200 hover:text-gray-800 hover:bg-gray-50']"
                @click.prevent="active = !active"
            >
                <strong v-if="title">{{title}}</strong>
                <span class="float-left" v-if="titleHtml" v-html="titleHtml"></span>
                <span class="float-right">
                    <font-awesome-icon icon="chevron-down" v-show="!active" />
                </span>
                <span class="float-right">
                    <font-awesome-icon icon="chevron-up" v-show="active" />
                </span>
            </a>
        </div>
        <div class="py-2 px-2" v-show="active">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: ['title','titleHtml','preopen'],
    data() {
        return {
            active: false,
        };
    },
    mounted() {
        if (this.preopen) {
            this.active = this.preopen;
        }
    },
};
</script>
